import TriggerDialogAction from './TriggerDialogAction';

export default TriggerDialogAction;
